import { MarkupType, ProductConfig } from '../types';

export function checkPrisingConfigurationAndSetDefault(config: ProductConfig): ProductConfig {
  return {
    ...config,
    cost: config?.cost ? +config.cost : 0,
    markup: config?.markup
      ? {
          type: config?.markup?.type ?? MarkupType.Flat,
          markup: config?.markup?.markup ? +config?.markup?.markup : 0,
        }
      : {
          type: MarkupType.Flat,
          markup: 0,
        },
    rateFactor: config?.rateFactor ? +config.rateFactor : 0,
    retailCost: config?.retailCost ? +config.retailCost : 0,
  };
}
